import { render, staticRenderFns } from "./OrderInfoAdm.vue?vue&type=template&id=6bbb921e&scoped=true&"
import script from "./OrderInfoAdm.vue?vue&type=script&lang=js&"
export * from "./OrderInfoAdm.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoAdm.vue?vue&type=style&index=0&id=6bbb921e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb921e",
  null
  
)

export default component.exports